import {
  buildWaLink,
  openWhatsApp,
  WHATSAPP_NUMBERS,
} from "@/lib/constants";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export const FloatingWhatsApp = () => (
  <a
    href={buildWaLink(WHATSAPP_NUMBERS[0])}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-button"
    onClick={(e) => {
      e.preventDefault();
      openWhatsApp("floating");
    }}
    aria-label="Chat dengan kami di WhatsApp"
    className="group fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 rounded-full bg-wa p-4 sm:px-5 text-white shadow-[0_4px_14px_0_rgb(37,211,102,0.45)] animate-wa-pulse transition-[background-color,transform] duration-200 hover:bg-wa-dark hover:scale-105 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2"
  >
    <WhatsAppIcon className="w-6 h-6" />
    <span className="hidden sm:inline font-heading text-sm font-bold">
      Chat Kami
    </span>
  </a>
);
